'use client';

import { c as _c } from "react/compiler-runtime";
import type { AccountTransactionDirection } from '@/modules/__generated__/graphql/switchboard-generated';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import { DesktopTransaction } from './desktop-transaction';
import { MobileTransaction } from './mobile-transaction';
export interface TransactionProps {
  label: string;
  date: string;
  toDate?: string | null;
  txHash: string | null;
  counterPartyName: string;
  counterPartyAddress: string;
  amount: number;
  highlightPositiveAmounts?: boolean;
  direction: AccountTransactionDirection;
}
function Transaction(t0) {
  const $ = _c(12);
  const {
    label,
    date,
    toDate,
    txHash,
    counterPartyName,
    counterPartyAddress,
    amount,
    highlightPositiveAmounts: t1,
    direction
  } = t0;
  const highlightPositiveAmounts = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      to: "md"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isMobile = useMediaQuery(t2);
  let t3;
  if ($[1] !== amount || $[2] !== counterPartyAddress || $[3] !== counterPartyName || $[4] !== date || $[5] !== direction || $[6] !== highlightPositiveAmounts || $[7] !== isMobile || $[8] !== label || $[9] !== toDate || $[10] !== txHash) {
    t3 = isMobile ? <MobileTransaction label={label} date={date} toDate={toDate} txHash={txHash} counterPartyName={counterPartyName} counterPartyAddress={counterPartyAddress} amount={amount} highlightPositiveAmounts={highlightPositiveAmounts} direction={direction} /> : <DesktopTransaction label={label} date={date} toDate={toDate} amount={amount} txHash={txHash} counterPartyName={counterPartyName} counterPartyAddress={counterPartyAddress} direction={direction} />;
    $[1] = amount;
    $[2] = counterPartyAddress;
    $[3] = counterPartyName;
    $[4] = date;
    $[5] = direction;
    $[6] = highlightPositiveAmounts;
    $[7] = isMobile;
    $[8] = label;
    $[9] = toDate;
    $[10] = txHash;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { Transaction };